(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-header"]) return;
  try {
    
document.addEventListener('click',function(event){var button=event.target.closest('.dm-menu-button');if(!button)return;var menu=document.getElementById('dm-mobile-nav');var open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));menu.hidden=open;document.body.classList.toggle('menu-open',!open)});

  } catch(e) { console.error(e); }
})();
})();
